import React, { memo } from 'react';

import { defaultSize, sizePropsTypes } from './icons.constants';

const ZoomInIcon = ({ size = defaultSize, ...props }) => (
  <svg
    fill="none"
    height={size}
    viewBox="0 0 24 24"
    width={size}
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M15.5 14L14.71 14L14.43 13.73C15.41 12.59 16 11.11 16 9.5C16 5.91 13.09 3 9.5 3S3 5.91 3 9.5C3 13.09 5.91 16 9.5 16C11.11 16 12.59 15.41 13.73 14.43L14 14.71L14 15.5L19 20.49L20.49 19L15.5 14ZM9.5 14C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5S14 7.01 14 9.5S11.99 14 9.5 14ZM10 7L9 7L9 9L7 9L7 10L9 10L9 12L10 12L10 10L12 10L12 9L10 9Z"
      fill="currentColor"
    />
  </svg>
);

ZoomInIcon.propTypes = {
  ...sizePropsTypes,
};

export default memo(ZoomInIcon);
